// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiWaveCreditType } from '../models/ApiWaveCreditType';
import { ApiWaveParticipationSubmissionStrategyType } from '../models/ApiWaveParticipationSubmissionStrategyType';
import { HttpFile } from '../http/http';

export class ApiWaveMin {
    'id': string;
    'name': string;
    'picture': string | null;
    'description_drop_id': string;
    /**
    * Unix timestamp in milliseconds of the most recent drop in this wave
    */
    'last_drop_time': number;
    'submission_type': ApiWaveParticipationSubmissionStrategyType | null;
    'authenticated_user_eligible_to_vote': boolean;
    'authenticated_user_eligible_to_participate': boolean;
    'authenticated_user_eligible_to_chat': boolean;
    'authenticated_user_admin': boolean;
    'visibility_group_id': string | null;
    'participation_group_id': string | null;
    'chat_group_id': string | null;
    'voting_group_id': string | null;
    'admin_group_id': string | null;
    'voting_period_start': number | null;
    'voting_period_end': number | null;
    'voting_credit_type': ApiWaveCreditType;
    'admin_drop_deletion_enabled': boolean;
    'forbid_negative_votes': boolean;
    'pinned': boolean;
    'identity_wave': boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "picture",
            "baseName": "picture",
            "type": "string",
            "format": ""
        },
        {
            "name": "description_drop_id",
            "baseName": "description_drop_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "last_drop_time",
            "baseName": "last_drop_time",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "submission_type",
            "baseName": "submission_type",
            "type": "ApiWaveParticipationSubmissionStrategyType",
            "format": ""
        },
        {
            "name": "authenticated_user_eligible_to_vote",
            "baseName": "authenticated_user_eligible_to_vote",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "authenticated_user_eligible_to_participate",
            "baseName": "authenticated_user_eligible_to_participate",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "authenticated_user_eligible_to_chat",
            "baseName": "authenticated_user_eligible_to_chat",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "authenticated_user_admin",
            "baseName": "authenticated_user_admin",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "visibility_group_id",
            "baseName": "visibility_group_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "participation_group_id",
            "baseName": "participation_group_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "chat_group_id",
            "baseName": "chat_group_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "voting_group_id",
            "baseName": "voting_group_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "admin_group_id",
            "baseName": "admin_group_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "voting_period_start",
            "baseName": "voting_period_start",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "voting_period_end",
            "baseName": "voting_period_end",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "voting_credit_type",
            "baseName": "voting_credit_type",
            "type": "ApiWaveCreditType",
            "format": ""
        },
        {
            "name": "admin_drop_deletion_enabled",
            "baseName": "admin_drop_deletion_enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "forbid_negative_votes",
            "baseName": "forbid_negative_votes",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "pinned",
            "baseName": "pinned",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "identity_wave",
            "baseName": "identity_wave",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiWaveMin.attributeTypeMap;
    }

    public constructor() {
    }
}


